import Endpoints from 'constants/Endpoints';
import {RestRequestPOST} from 'libs/RestRequest';

const notificationSend = async (functionalityName) => {
    return await RestRequestPOST(Endpoints.SALES_NOTIFICATION_SEND(functionalityName));
}

export default {notificationSend}